export default "/images/vendor/@coreui/icons/svg/flag/cif-sg.svg?0c9d004bce40860b6ad868a6f1a24f00";